import { Box } from "@mui/material";
import { overviewCardStyle } from "../../misc/backofficeTheme";
import { useAutovioContext } from "../../hooks/useAutovioContext.js";
import { useGetOne } from "react-admin";
import type { DrivingSchool } from "../../providers/drivingSchoolsProvider.js";
import { Thread } from "../../lists/Thread.js";
import { NotesAndDocuments } from "../../lists/NotesAndDocuments.js";

export function NotesOrThreadWrapper() {
  const [{ drivingSchoolId }] = useAutovioContext();
  const { data: drivingSchool } = useGetOne<DrivingSchool>(
    "drivingSchools",
    { id: drivingSchoolId ?? "" },
    { enabled: !!drivingSchoolId },
  );

  if (!drivingSchool) {
    return null;
  }

  return (
    <Box sx={{ ...overviewCardStyle, p: 0, boxShadow: "none", borderRadius: "16px", overflow: "hidden" }}>
      {drivingSchool.threadId ? (
        <Thread threadId={drivingSchool.threadId} />
      ) : (
        <NotesAndDocuments source="drivingSchool" />
      )}
    </Box>
  );
}
